
import Collapse from 'react-bootstrap/Collapse';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { TransitCuspalInInterval } from './TransitCuspalInInterval';

export function TransitCuspalInIntervalTab ({menuArray,transitIntervalData,date,startTime,endTime,setDate,setStartTime,setEndTime,handleCalculate}) {
  return(
    <Collapse in={menuArray[1]} className="m-0 p-0 ">
      <Row id="transitChartTab" className="m-0 p-0">
        <Col xs={12} className="m-0 p-0">
          <TransitCuspalInInterval transitIntervalData={transitIntervalData} date={date} startTime={startTime} endTime={endTime} setDate={setDate} setStartTime={setStartTime} setEndTime={setEndTime} handleCalculate={handleCalculate}/>
        </Col>
      </Row>
    </Collapse>
    );
}